module.exports = __webpack_public_path__ + "img/footer_charger.be8bb4a7.png";